export const customerLegal = {
  get: 'customerEndpoint/getPrivacyInfo',
};
